<template>
  <div class="auth-layout">
    <FLoader />
    <div v-if="!isUserAuthenticated">
      <router-view />
    </div>
    <div v-else>
      <nest_header v-if="isHeaderShow" />
      
      <div v-if="!isShowLoginPage && !isSilentLoginPage" :class="(!isHeaderShow || isProxyLoggedIn) ? 'mt-[20px]' : 'relative -mt-[35px]'">
        <proxyLogin v-if="isProxyLoggedIn && !isShowLoginPage" class="mb-[20px]"></proxyLogin>
        <div class="px-[15px] laptop:container laptop:mx-auto pb-[20px]">
          <router-view />
        </div>
      </div>
      <div v-else>
        <div>
          <router-view />
        </div>
      </div>
      <FooterPartial v-if="false" />
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>


<script>
import FooterPartial from "../../components/layouts/footer/FooterPartial.vue";
import nest_header from "../../components/nest_components/nest_header.vue";
import { mapActions, mapGetters} from "vuex";
import proxyLogin from "../partialComponent/proxyLogin.vue";
export default {
  name: 'AuthLayout',

  components: {
    FooterPartial,
    nest_header,
    proxyLogin
  },


  data() {
    return {
      td: '',
    };
  },

  computed: {
      ...mapGetters(["user"]),
      isProxyLoggedIn() {
        return this.$helper.isProxyLoggedIn();
      },
      isFromMobile() {
        return this.$route.query.is_from_mobile ?? 0;
      },
      isSilentLoginPage() {
        return this.$route.name === 'silentLogin';
      },
    isShowLoginPage(){
      if (this.$route.name == 'login'){
        return true
      }
      else{
        return false
      }
    },
    isHeaderShow() {
      if ((this.$route.query.is_from_mobile ?? 0) == 1) {
        return false
      } else if (this.$route.name == 'paymentLinkCheckoutSuccess' || this.$route.name == 'paymentLinkCheckoutFailed' || this.$route.name == 'login' ){
        return false
      } else {
        return true
      }
    },

    isUserAuthenticated() {
      let tempUser = !this.$helper.isEmpty(this.user) ? this.user : localStorage.getItem("user") ?? null
      return tempUser ? true : false
    },
  },

    watch: {
    user: function () {

    },
  },

};
</script>